"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverableResponse = void 0;
var DeliverableResponse;
(function (DeliverableResponse) {
    let type;
    (function (type) {
        type["BOT_COMMAND"] = "botCommand";
        type["BRIEF"] = "brief";
        type["CONTRACT"] = "contract";
        type["CREATOR_PAY_PER_EVENT"] = "creatorPayPerEvent";
        type["LIVE_STREAM"] = "liveStream";
        type["OVERLAY"] = "overlay";
        type["PANEL_BANNER"] = "panelBanner";
        type["PAY_PER_EVENT"] = "payPerEvent";
        type["PAY_PER_EVENT_BRACKET"] = "payPerEventBracket";
        type["CUSTOM"] = "custom";
        type["DYNAMIC_DESCRIPTION_WIDGET"] = "dynamicDescriptionWidget";
        type["TIK_TOK_CREATIVE"] = "tikTokCreative";
        type["YOU_TUBE_VIDEO"] = "youTubeVideo";
        type["MARKDOWN_BRIEF"] = "markdownBrief";
    })(type = DeliverableResponse.type || (DeliverableResponse.type = {}));
    let prerequisitesOperator;
    (function (prerequisitesOperator) {
        prerequisitesOperator["ALL"] = "all";
        prerequisitesOperator["ANY"] = "any";
    })(prerequisitesOperator = DeliverableResponse.prerequisitesOperator || (DeliverableResponse.prerequisitesOperator = {}));
    let status;
    (function (status) {
        status["INCOMPLETE"] = "incomplete";
        status["BLOCKED"] = "blocked";
        status["READY"] = "ready";
        status["UNDER_NEGOTIATION"] = "underNegotiation";
        status["GOAL_COMPLETE"] = "goalComplete";
        status["GOAL_IN_PROGRESS"] = "goalInProgress";
        status["MANUAL_OVERRIDE"] = "manualOverride";
        status["PENDING_REVIEW"] = "pendingReview";
    })(status = DeliverableResponse.status || (DeliverableResponse.status = {}));
    let negotiationStatus;
    (function (negotiationStatus) {
        negotiationStatus["WAITING"] = "waiting";
        negotiationStatus["APPROVED"] = "approved";
        negotiationStatus["REJECTED"] = "rejected";
    })(negotiationStatus = DeliverableResponse.negotiationStatus || (DeliverableResponse.negotiationStatus = {}));
})(DeliverableResponse = exports.DeliverableResponse || (exports.DeliverableResponse = {}));
